import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormOne from "./FormOne";
import FormThree from "./FormThree";
import EditButtons from "../../../components/EditButtons";
import { CancelButton } from "../../css components/Button";
import { ButtonFooter, PageHeader, Paper } from "../../../components";

export default function FormDisplay({
  state,
  dispatch,
  fields,
  editState,
  setEditState,
  formikProps,
  component,
  handleClose,
  categories,
  setFields,
}) {
  const navigate = useNavigate();

  const { parentState } = useSelector((state) => state.memberDetails);

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        {component !== "dialog" && (
          <PageHeader
            pageName={"Audience"}
            pageHeader={
              !formikProps.values.ID
                ? "Let's create audience group"
                : formikProps.values.audience_group?.value
            }
            buttons={[
              parentState !== "SA" && formikProps.values.isEditable ? (
                !Boolean(handleClose) && (
                  <EditButtons
                    editState={editState}
                    setEditState={setEditState}
                  />
                )
              ) : (
                <CancelButton variant="outlined" onClick={() => navigate(-1)}>
                  Back
                </CancelButton>
              ),
            ]}
          />
        )}
      </Grid>

      <Grid size={12}>
        <FormOne
          setFields={setFields}
          categories={categories}
          state={state}
          dispatch={dispatch}
          fields={fields}
          formikProps={formikProps}
          editState={editState}
          setEditState={setEditState}
        />

        <Paper>
          <FormThree
            state={state}
            dispatch={dispatch}
            fields={fields}
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
          />
        </Paper>

        {editState && (
          <Grid size={12}>
            <ButtonFooter
              ID={formikProps.values.ID}
              editState={editState}
              setEditState={setEditState}
              formikProps={{
                ...formikProps,
                dirty: true,
              }}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
